export default __webpack_public_path__ + "static/media/profile-icon.b9e4633c.svg";